import React from "react";
import PropTypes, { node } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  trackPageInteraction,
  getGender,
  ANALYTICS_INTERACTION_CLICK,
  ANALYTICS_POSITION_HEADER,
  ANALYTICS_CONTEXT
} from "@src/helpers/events";
import { addAnalyticsDataToLink } from "@template/helpers/addAnalyticsDataToLink";

const NavAnchor = props => {
  const {
    item,
    children,
    headerTopBarHidden,
    // eslint-disable-next-line no-unused-vars
    dispatch,
    ...restOfProps
  } = props;
  const { gender, label } = item;

  const handleClick = () => {
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: getGender(gender)
      }
    });
  };

  const target = item.linkType === "external" ? "_blank" : null;

  return (
    <a
      {...restOfProps}
      onClick={handleClick}
      href={addAnalyticsDataToLink({
        ...item,
        headerTopBarHidden
      })}
      target={target}
    >
      {children}
    </a>
  );
};

NavAnchor.propTypes = {
  item: navigationPropType.isRequired,
  children: node.isRequired,
  headerTopBarHidden: PropTypes.bool,
  dispatch: PropTypes.func
};

const getTopBarMVTStatus = state =>
  get(state, `features["emf-82-desktop-hide-top-grey-bar"].hidden`);

const mapStateToProps = state => ({
  headerTopBarHidden: getTopBarMVTStatus(state)
});

export default connect(mapStateToProps)(NavAnchor);
